import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";
import { getNIHClinGenDiseaseValidityData } from "../../../../state/selectors/NIHClinGenDiseaseValidity.selectors";
import { NIHClinGenDiseaseValidityType } from "../../../componentTypes/NIHClinGenDiseaseValidityType";

const GeneNIHClinGenDiseaseValidityCard = ({
  card,
  nhiClinGenDiseaseValidityData,
}) => {
  const isDisabled = !Object.keys(nhiClinGenDiseaseValidityData || {}).length;
  return <CardWrapper {...card} isDisabled={isDisabled} />;
};

GeneNIHClinGenDiseaseValidityCard.propTypes = {
  card: PropTypes.instanceOf(Card).isRequired,
  nhiClinGenDiseaseValidityData: NIHClinGenDiseaseValidityType,
};

GeneNIHClinGenDiseaseValidityCard.defaultProps = {
  nhiClinGenDiseaseValidityData: {},
};

const mapStateToProps = (state) => ({
  nhiClinGenDiseaseValidityData: getNIHClinGenDiseaseValidityData(state),
});

export default connect(mapStateToProps, {})(GeneNIHClinGenDiseaseValidityCard);
